export default function cmsItemsArrayIsEqual<T extends { contentId: string }>(
  a: T[] | null,
  b: T[] | null
): boolean {
  if (!a?.length && !b?.length) return true;
  if (!a?.length || !b?.length) return false;

  return a.every(aItem => b.some(bItem => bItem.contentId === aItem.contentId));
}
